import request from "@utils/request";

const SearchApiService = {
    /**
     * 查询
     * @param data
     */
    getDetail(data={}) {
        return request({
            url:  '/mg/po/essa-one/list/ddp-in-abnormal',
            method: "POST",
            data
        });
    },

    /**
     * 翻译
     * @param data
     */
    getTranslate(data={}) {
        return request({
            // url:  '/service/tool/translate/translate',
            url:  '/service/tool/translate/do-translate',
            method: "POST",
            data
        });
    },

    /**
     * 处理 /service
     * @param data
     */
    handleAbnormal(data={}) {
        return request({
            url:  '/mg/w/po/detail/ddp/handle-abnormal-item',
            method: "POST",
            data
        });
    }
};

export default SearchApiService;
